import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  resolveFieldglassIssue,
  type ResolveFieldglassIssueRequest,
} from 'api/admin/fieldglass/resolveFieldglassIssue'
import { fieldglassKeys } from './keys'

export const useResolveFieldglassIssueMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: ResolveFieldglassIssueRequest) =>
      resolveFieldglassIssue(request),
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: fieldglassKeys.all,
      }),
  })
}
